import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import he from 'he';
import moment from 'moment';
import join from 'nllib/src/uri/join';
import get_url_prefix from '../../get_url_prefix';

const call_UnionPay_b2c_data_interface = function (pParameter) {
  if (!pParameter) pParameter = {};

  const url_prefix = get_url_prefix({
    appKey: `UnionPay-b2c`,
  });
  const action = url_prefix;

  const form = pParameter;

  let html = ``;
  html += `<form style="display: none;" enctype='application/x-www-form-urlencoded' action="${action}" method="post">`;
  _.each(form, function (property_value, property_name) {
    const s = he.escape(property_value);
    html += `<input type="text" name="${property_name}" value="${s}"/><br/>`;
  });
  html += `<input id="btn-submit" type="submit" value="" />`;
  html += `</form>`;
  html += `<script>`;
  html += `document.getElementById('btn-submit').click();`;
  html += `</script>`;

  // 参考：https://stackoverflow.com/questions/17493027/can-i-open-a-new-window-and-populate-it-with-a-string-variable
  const w = global.open(`about:blank`);
  w.document.write(html);

  return Q.resolve();
};

export default call_UnionPay_b2c_data_interface;
